// extracted by mini-css-extract-plugin
export default {"title":"_1EMYUTIrb5D0j2zW1IE6Fi","titleMFA":"_1qIXNU1kGlAcaff-El_3nM","FAQN":"_3Z3w1W3pw1ePEN0rg0uZWe","danger":"_2lOwXz4wuD6NIeBJSWudxq"};